import React from 'react';
import { Row, Col, Card, Typography, Timeline, Statistic } from 'antd';
import { 
  TeamOutlined, 
  TrophyOutlined, 
  HeartOutlined, 
  GlobalOutlined,
  SafetyOutlined,
  DollarCircleOutlined
} from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const About: React.FC = () => {
  return (
    <div>
      {/* Page Header */}
      <div className="page-header">
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <Title level={1} style={{ color: 'white', marginBottom: '10px' }}>
            About JEJELY ULTIMATE LIMITED
          </Title>
          <Paragraph style={{ color: 'white', fontSize: '1.1rem' }}>
            Your trusted partner in microfinance and personal lending solutions
          </Paragraph>
        </div>
      </div>

      {/* Company Overview */}
      <div className="content-section">
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <Row gutter={[40, 40]} align="middle">
            <Col xs={24} lg={12}>
              <Title level={2}>Who We Are</Title>
              <Paragraph style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                JEJELY ULTIMATE LIMITED is a licensed microfinance institution dedicated to providing 
                accessible and reliable financial services to individuals and small businesses across Nigeria. 
                We believe in the power of financial inclusion and are committed to helping our clients 
                achieve their financial goals through innovative lending solutions.
              </Paragraph>
              <Paragraph style={{ fontSize: '1.1rem', lineHeight: '1.8' }}>
                Since our establishment, we have been at the forefront of microfinance innovation, 
                combining traditional banking principles with modern technology to deliver exceptional 
                service to our customers. Our team of experienced professionals is dedicated to 
                understanding your unique financial needs and providing tailored solutions.
              </Paragraph>
            </Col>
            <Col xs={24} lg={12}>
              <Card style={{ textAlign: 'center', padding: '40px 20px' }}>
                <TeamOutlined style={{ fontSize: '4rem', color: '#1890ff', marginBottom: '20px' }} />
                <Title level={3}>Our Mission</Title>
                <Paragraph style={{ fontSize: '1.1rem' }}>
                  To provide accessible, reliable, and innovative microfinance solutions that empower 
                  individuals and small businesses to achieve their financial aspirations and contribute 
                  to economic growth in Nigeria.
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* Mission, Vision, Values */}
      <div style={{ background: '#f8f9fa', padding: '60px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <Title level={2}>Our Core Principles</Title>
          </div>
          
          <Row gutter={[30, 30]}>
            <Col xs={24} md={8}>
              <Card style={{ height: '100%', textAlign: 'center' }}>
                <TrophyOutlined style={{ fontSize: '3rem', color: '#1890ff', marginBottom: '20px' }} />
                <Title level={3}>Our Vision</Title>
                <Paragraph>
                  To be the leading microfinance institution in Nigeria, recognized for our 
                  commitment to financial inclusion, innovation, and customer satisfaction.
                </Paragraph>
              </Card>
            </Col>
            
            <Col xs={24} md={8}>
              <Card style={{ height: '100%', textAlign: 'center' }}>
                <HeartOutlined style={{ fontSize: '3rem', color: '#52c41a', marginBottom: '20px' }} />
                <Title level={3}>Our Values</Title>
                <Paragraph>
                  Integrity, transparency, customer focus, innovation, and social responsibility 
                  guide everything we do in serving our clients and communities.
                </Paragraph>
              </Card>
            </Col>
            
            <Col xs={24} md={8}>
              <Card style={{ height: '100%', textAlign: 'center' }}>
                <GlobalOutlined style={{ fontSize: '3rem', color: '#722ed1', marginBottom: '20px' }} />
                <Title level={3}>Our Commitment</Title>
                <Paragraph>
                  We are committed to promoting financial inclusion and economic empowerment 
                  across Nigeria through accessible and responsible lending practices.
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      {/* Company Statistics */}
      {/* <div style={{ padding: '60px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <Title level={2}>Our Impact</Title>
            <Paragraph style={{ fontSize: '1.1rem', color: '#666' }}>
              Numbers that reflect our commitment to serving the community
            </Paragraph>
          </div>
          
          <Row gutter={[30, 30]}>
            <Col xs={12} sm={6}>
              <Card style={{ textAlign: 'center' }}>
                <Statistic
                  title="Active Customers"
                  value={2500}
                  suffix="+"
                  valueStyle={{ color: '#1890ff' }}
                />
              </Card>
            </Col>
            
            <Col xs={12} sm={6}>
              <Card style={{ textAlign: 'center' }}>
                <Statistic
                  title="Loans Disbursed"
                  value={15000}
                  suffix="+"
                  valueStyle={{ color: '#52c41a' }}
                />
              </Card>
            </Col>
            
            <Col xs={12} sm={6}>
              <Card style={{ textAlign: 'center' }}>
                <Statistic
                  title="Total Amount"
                  value={2500000000}
                  prefix="₦"
                  precision={0}
                  valueStyle={{ color: '#722ed1' }}
                />
              </Card>
            </Col>
            
            <Col xs={12} sm={6}>
              <Card style={{ textAlign: 'center' }}>
                <Statistic
                  title="Years of Service"
                  value={8}
                  suffix="+"
                  valueStyle={{ color: '#fa8c16' }}
                />
              </Card>
            </Col>
          </Row>
        </div>
      </div> */}

      {/* Our Journey */}
      {/* <div style={{ background: '#f8f9fa', padding: '60px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <Title level={2}>Our Journey</Title>
            <Paragraph style={{ fontSize: '1.1rem', color: '#666' }}>
              Key milestones in our growth and development
            </Paragraph>
          </div>
          
          <Row justify="center">
            <Col xs={24} lg={16}>
              <Timeline
                items={[
                  {
                    children: (
                      <div>
                        <Title level={4}>2016 - Foundation</Title>
                        <Paragraph>
                          JEJELY ULTIMATE LIMITED was established with a vision to provide 
                          accessible microfinance services to underserved communities in Nigeria.
                        </Paragraph>
                      </div>
                    ),
                  },
                  {
                    children: (
                      <div>
                        <Title level={4}>2018 - License Acquisition</Title>
                        <Paragraph>
                          Obtained full microfinance license from the Central Bank of Nigeria, 
                          enabling us to expand our services and reach more customers.
                        </Paragraph>
                      </div>
                    ),
                  },
                  {
                    children: (
                      <div>
                        <Title level={4}>2020 - Digital Transformation</Title>
                        <Paragraph>
                          Launched digital lending platform to provide faster and more convenient 
                          loan processing and management services.
                        </Paragraph>
                      </div>
                    ),
                  },
                  {
                    children: (
                      <div>
                        <Title level={4}>2022 - Expansion</Title>
                        <Paragraph>
                          Expanded operations to serve customers across multiple states in Nigeria, 
                          increasing our impact and reach.
                        </Paragraph>
                      </div>
                    ),
                  },
                  {
                    children: (
                      <div>
                        <Title level={4}>2024 - Innovation</Title>
                        <Paragraph>
                          Continued innovation in microfinance solutions, focusing on financial 
                          inclusion and customer-centric services.
                        </Paragraph>
                      </div>
                    ),
                  },
                ]}
              />
            </Col>
          </Row>
        </div>
      </div> */}

      {/* Why Choose Us */}
      <div style={{ padding: '60px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <Title level={2}>Why Choose JEJELY ULTIMATE LIMITED?</Title>
          </div>
          
          <Row gutter={[30, 30]}>
            <Col xs={24} md={12}>
              <Card>
                <SafetyOutlined style={{ fontSize: '2rem', color: '#1890ff', marginBottom: '15px' }} />
                <Title level={4}>Licensed & Regulated</Title>
                <Paragraph>
                  We are fully licensed by the Central Bank of Nigeria and operate under strict 
                  regulatory guidelines to ensure the safety and security of your funds.
                </Paragraph>
              </Card>
            </Col>
            
            <Col xs={24} md={12}>
              <Card>
                <DollarCircleOutlined style={{ fontSize: '2rem', color: '#52c41a', marginBottom: '15px' }} />
                <Title level={4}>Competitive Rates</Title>
                <Paragraph>
                  We offer competitive interest rates and transparent fee structures, ensuring 
                  you get the best value for your borrowing needs.
                </Paragraph>
              </Card>
            </Col>
            
            <Col xs={24} md={12}>
              <Card>
                <TeamOutlined style={{ fontSize: '2rem', color: '#722ed1', marginBottom: '15px' }} />
                <Title level={4}>Experienced Team</Title>
                <Paragraph>
                  Our team of financial experts brings years of experience in microfinance 
                  and is dedicated to providing personalized service to each customer.
                </Paragraph>
              </Card>
            </Col>
            
            <Col xs={24} md={12}>
              <Card>
                <GlobalOutlined style={{ fontSize: '2rem', color: '#fa8c16', marginBottom: '15px' }} />
                <Title level={4}>Local Expertise</Title>
                <Paragraph>
                  Deep understanding of the Nigerian market and local business environment, 
                  enabling us to provide relevant and effective financial solutions.
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default About;
